var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticClass: "full-width",
      attrs: {
        placeholder: _vm.placeholder || _vm.$t("chooseText"),
        multiple: _vm.multiple,
        disabled: _vm.disabled,
        "collapse-tags": _vm.collapseTags,
        size: _vm.size,
        filterable: "",
        clearable: "",
        loading: _vm.loading,
      },
      on: { change: _vm.onChange, clear: _vm.onClear },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    _vm._l(_vm.options, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }